/*
 * @Description:
 * @version:
 * @Author: 李云飞
 * @Date: 2023-07-13 16:18:55
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-01-09 15:49:47
 */

import { createApp } from 'vue';
import { router } from './router/index';
import { createPinia } from 'pinia';
import App from './App.vue';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import * as antIcons from '@ant-design/icons-vue';
import lodash from 'lodash';
import smartEnumPlugin from '@/plugins/smart-enums-plugin';
import constants from '@/constants/index';
import { useUserStore } from '@/store/user.js';
import { useSystemStore } from '@/store/system.js';

const vueApp = createApp(App);
// 先 use(pinia)，再 use(router)
const store = createPinia();
vueApp.use(store);

vueApp.use(router);
vueApp.use(Antd);
vueApp.use(smartEnumPlugin, constants);

Object.keys(antIcons).forEach((key) => {
  vueApp.component(key, antIcons[key]);
});

vueApp.config.globalProperties.$antIcons = antIcons;
vueApp.config.globalProperties.$lodash = lodash;

useUserStore().getStorageUserInfo();
useSystemStore().getStorageTags();

vueApp.mount('#app');
